"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconPlayCircle', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.95 5.9C7.72274 5.72956 7.41868 5.70214 7.16459 5.82918C6.9105 5.95623 6.75 6.21593 6.75 6.5V9.5C6.75 9.78408 6.9105 10.0438 7.16459 10.1708C7.41868 10.2979 7.72274 10.2705 7.95 10.1L9.95 8.6C10.1389 8.45836 10.25 8.23607 10.25 8C10.25 7.76394 10.1389 7.54165 9.95 7.4L7.95 5.9Z', 'M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M9.5547 7.16795C9.24784 6.96338 8.8533 6.94431 8.52814 7.11833C8.20298 7.29235 8 7.63121 8 8V12C8 12.3688 8.20298 12.7077 8.52814 12.8817C8.8533 13.0557 9.24784 13.0366 9.5547 12.8321L12.5547 10.8321C12.8329 10.6466 13 10.3344 13 10C13 9.66565 12.8329 9.35342 12.5547 9.16795L9.5547 7.16795Z', 'M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M11.6 8.20001C11.297 7.97274 10.8916 7.93619 10.5528 8.10558C10.214 8.27497 10 8.62123 10 9.00001V15C10 15.3788 10.214 15.725 10.5528 15.8944C10.8916 16.0638 11.297 16.0273 11.6 15.8L15.6 12.8C15.8518 12.6112 16 12.3148 16 12C16 11.6852 15.8518 11.3889 15.6 11.2L11.6 8.20001Z', 'M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M15.3602 11.2712C14.902 10.9504 14.3034 10.9112 13.8073 11.1695C13.3112 11.4278 13 11.9407 13 12.5V19.5C13 20.0593 13.3112 20.5722 13.8073 20.8305C14.3034 21.0888 14.902 21.0496 15.3602 20.7289L20.3602 17.2289C20.7612 16.9482 21 16.4895 21 16C21 15.5105 20.7612 15.0518 20.3602 14.7712L15.3602 11.2712Z', 'M16 31C24.4375 31 31 24.2759 31 16C31 7.72414 24.2759 1 16 1C7.72414 1 1 7.72414 1 16C1 24.2759 7.5625 31 16 31ZM16 28C22.7596 28 28 22.6402 28 16C28 9.38099 22.619 4 16 4C9.38099 4 4 9.38099 4 16C4 22.6402 9.24044 28 16 28Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;